export default {
  SET_CONFIGURACOES(state, payload) {
    state.configuracoes = payload;
  },
  SET_NOTIFICACOES(state, payload) {
    state.notificacoes = payload;
  },
  FILTRAR(state, payload) {
    state.filtro = typeof payload === 'string' ? payload.toUpperCase() : '';
  },
};
